import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { ArrowRight, ExternalLink } from "lucide-react";

const Projects = () => {
  const { lang } = useLanguage();
  const t = content[lang].projects;

  return (
    <section id="projects" className="py-12">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-xl font-semibold mb-12 text-muted-foreground uppercase tracking-wider text-sm border-b border-border pb-4">
            {t.title}
        </h2>
        
        <div className="flex flex-col gap-20">
          {t.items.map((project, index) => (
            <div key={index} className="group">
                <div className="flex flex-col gap-6">
                    {/* Image Container - Clickable */}
                    <a 
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block overflow-hidden rounded-2xl border border-border/50 bg-secondary/20 aspect-[16/9] relative shadow-sm hover:shadow-md transition-all duration-500"
                    >
                         <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors z-10" />
                         <img 
                            src={project.image} 
                            alt={project.title}
                            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                         />
                    </a>

                    {/* Content */}
                    <div className="flex flex-col md:flex-row md:items-start justify-between gap-6">
                        <div className="space-y-3 max-w-xl">
                             <div className="flex items-center gap-3">
                                <h3 className="text-2xl font-bold text-foreground">
                                    {project.title}
                                </h3>
                             </div>
                            
                            <div className="text-lg font-medium text-primary/80">
                                {project.subtitle}
                            </div>
                            
                            <p className="text-muted-foreground leading-relaxed text-lg">
                                {project.desc}
                            </p>
                        </div>

                        {/* Button */}
                        <a 
                            href={project.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground text-background font-medium hover:bg-foreground/90 transition-colors shrink-0 self-start md:self-start mt-2"
                        >
                            {t.visit}
                            <ExternalLink className="w-4 h-4" />
                        </a>
                    </div>
                </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
